import './FeatureMapView.scss'
import Sidebar from './Sidebar'
import Visualization from './Visualization'

const FeatureMapView = () => {
    return (
        <div className='feature__map__view__container'>
            <Sidebar />
            <Visualization />
        </div>
    )
}

export default FeatureMapView